<template>
  <div class="header-container">
    <div class="left">
      <el-image
        style="width: 196px; height: 45px; cursor: pointer"
        :src="require('../assets/phak.png')"
        fit="contain"
        @click.native="goIndex"
      >
      </el-image>
      <!-- <el-menu
        :default-active="activeIndex"
        class="el-menu-demo"
        mode="horizontal"
        @select="handleSelect"
        style=""
      >
        <el-menu-item index="1">处理中心</el-menu-item>
        <el-submenu index="2">
          <template slot="title">我的工作台</template>
          <el-menu-item index="2-1">选项1</el-menu-item>
          <el-menu-item index="2-2">选项2</el-menu-item>
          <el-menu-item index="2-3">选项3</el-menu-item>
          <el-submenu index="2-4">
            <template slot="title">选项4</template>
            <el-menu-item index="2-4-1">选项1</el-menu-item>
            <el-menu-item index="2-4-2">选项2</el-menu-item>
            <el-menu-item index="2-4-3">选项3</el-menu-item>
          </el-submenu>
        </el-submenu>
        <el-menu-item index="3" disabled>消息中心</el-menu-item>
        <el-menu-item index="4"
          ><a href="https://www.ele.me" target="_blank"
            >订单管理</a
          ></el-menu-item
        >
      </el-menu> -->

      <el-row class="block-col-2" :gutter="20" style="display: flex">
        <el-col :span="12">
          <el-dropdown>
            <span class="el-dropdown-link">
              版本日志<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu
              slot="dropdown"
              style="padding-right: 40px; padding-top: 30px"
            >
              <el-timeline :reverse="reverse">
                <el-timeline-item
                  v-for="(activity, index) in activities"
                  :key="index"
                  :timestamp="activity.timestamp"
                  :icon="activity.icon"
                  :color="activity.color"
                >
                  {{ activity.content }}
                </el-timeline-item>
              </el-timeline>
            </el-dropdown-menu>
          </el-dropdown>
        </el-col>
        <el-col :span="12">
          <el-dropdown>
            <span class="el-dropdown-link">
              授课教师<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                ><a
                  href="https://shi.buaa.edu.cn/06585/zh_CN/index.htm"
                  target="_blank"
                  style="text-decoration: none; color: #000"
                  >朱颖书记</a
                ></el-dropdown-item
              >
              <el-dropdown-item
                ><a
                  href="https://shi.buaa.edu.cn/hexiang/zh_CN/index/173580/list/index.htm"
                  target="_blank"
                  style="text-decoration: none; color: #000"
                  >何翔老师</a
                ></el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </el-col>
        <el-col :span="12">
          <el-dropdown>
            <span class="el-dropdown-link">
              意见反馈<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown" v-show="false">
              <el-dropdown-item @click.native="suggestionFeedback">
                <a target="_blank" style="text-decoration: none; color: #000"
                  >意见反馈</a
                >
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </el-col>
      </el-row>
      <!-- <ball ></ball> -->
    </div>

    <div></div>

    <el-dropdown style="margin-left: 10%; font-size: 15px">
      <span>{{ helloSpan }}</span>

      <i class="el-icon-user" style="margin-left: 15px; font-size: 18px"></i>
      <el-dropdown-menu slot="dropdown">
        <!-- <el-dropdown-item
          @click.native="toUser"
          v-show="this.$store.state.user.isLogin"
          >个人中心</el-dropdown-item
        > -->
        <el-dropdown-item
          @click.native="toChangePassword"
          v-show="this.$store.state.user.isLogin"
          >修改密码</el-dropdown-item
        >
        <el-dropdown-item
          @click.native="logOut"
          v-show="this.$store.state.user.isLogin"
          >退出登录</el-dropdown-item
        >
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
import user from "../api/module/user.js";
import ball from "./other/ball.vue";

export default {
  components: { ball },
  name: "Header",
  data() {
    return {
      userInfo: {
        jobNumber: "20161407",
        name: "邓向杰",
        phone: "13650955990",
      },
      reverse: false,
      activities: [
      {
          content: `新增答对自动跳转下一题的功能；修复了一些已知的问题
          `,
          timestamp: "版本号1.3 更新时间：2024-06-22",
          icon: "el-icon-check",
          color: "#0bbd87",
        },
        {
          content: `新增收藏题练习模块
          `,
          timestamp: "版本号1.2 更新时间：2024-06-20",
          icon: "el-icon-check",
          color: "#0bbd87",
        },
        {
          content: `修复了修改密码页面原密码无法键入英文字母的bug
          `,
          timestamp: "版本号1.1 更新时间：2024-06-04",
          icon: "el-icon-check",
          color: "#0bbd87",
        },
        {
          content: "系统上线",
          timestamp: "版本号1.0 更新时间：2024-04-06",
          icon: "el-icon-check",
          color: "#0bbd87",
        },
      ],
    };
  },
  computed: {
    helloSpan() {
      if (this.$store.state.user.isLogin == false) {
        return "请登录";
      } else {
        if (this.$store.state.user.role == 1) {
          return this.$store.state.user.name + "同学，您好";
        } else if (this.$store.state.user.role == 2) {
          return this.$store.state.user.name + "老师，您好";
        }
        return "未知用户";
      }
    },
  },
  methods: {
    suggestionFeedback() {
      // this.$message({
      //   message: "此功能仍在开发中",
      //   type: "info",
      // });
      // let path = window.location.protocol + "//" + "https://www.wenjuan.com/s/UZBZJvBxDEx/#";
      // window.location.href = path;
      window.open("https://www.wenjuan.com/s/UZBZJvBxDEx/#", "_blank");
    },
    toChangePassword() {
      this.$router.push({
        path: "/password/change",
      });
    },
    goIndex() {
      this.$confirm("确定返回首页吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$router.push({
            path: "/",
          });
          this.$message({
            message: "返回首页",
            type: "info",
          });
        })
        .catch(() => {});
    },
    toUser() {
      // user.userLogin(this.userInfo).then(({data:res,code}) => {
      //   console.log(res)
      // });
      this.$router.push({
        path: "/myhome",
      });
    },
    logOut() {
      this.$store.commit("logOut");
      this.$message({
        message: "退出登录成功",
        type: "success",
      });
    },
  },
};
</script>

<style scoped lang="scss">
.el-dropdown-link {
  cursor: pointer;
  color: #24292e;
  font-size: 15px;
  font-weight: 500;
  &:hover {
    color: rgb(148, 1, 119);
  }
}
.el-icon-arrow-down {
  font-size: 12px;
}
.header-container {
  .left {
    display: flex;
    align-items: center;
  }
  user-select: none;
  z-index: 2;
  width: 97%;
  max-width: 100%;

  padding-top: 10px;
  padding-bottom: 10px;
  padding-right: 0;
  position: relative;
  font-size: 18px;
  color: var(--white);
  text-align: left;
  font-family: Quicksand, sans-serif;

  font-weight: 600;
  line-height: 100%;
  justify-content: space-between;
  align-items: center;
  margin-left: auto;
  margin-right: auto;

  display: flex;
}
</style>